import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-b from-[rgb(var(--color-neutral-100))] to-white" data-id="element-225">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=1600')] bg-cover bg-center opacity-20" data-id="element-226"></div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 py-8 sm:py-20 text-center" data-id="element-227">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-[rgb(var(--color-neutral-900))] mb-2 sm:mb-6 leading-tight" data-id="element-228">
          De échte oorzaak van stress, jeuk, lichamelijke klachten, en
          gedragsproblemen zit vaak op een onverwachte plek.
        </h1>

        <p className="text-lg sm:text-xl lg:text-2xl text-[rgb(var(--color-neutral-800))] mb-8 sm:mb-12 font-medium" data-id="element-229">
          Wist je dat ongeveer 70% van het immuunsysteem van je hond zich in
          zijn darmen bevindt?
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4 max-w-4xl mx-auto mb-8 sm:mb-12" data-id="element-230">
          {[{
          icon: '🐾',
          text: 'Terugkerende jeuk'
        }, {
          icon: '💨',
          text: 'Diarree & winderigheid'
        }, {
          icon: '✨',
          text: 'Doffe vacht'
        }, {
          icon: '😴',
          text: 'Vermoeidheid'
        }, {
          icon: '🍽️',
          text: 'Kieskeurig eten'
        }, {
          icon: '😰',
          text: 'Gedragsproblemen'
        }].map((problem, index) => <div key={index} className="bg-white/90 backdrop-blur-sm p-4 sm:p-6 rounded-xl shadow-md" data-id="element-231">
              <div className="text-3xl sm:text-4xl mb-2" data-id="element-232">{problem.icon}</div>
              <p className="font-semibold text-sm sm:text-base text-[rgb(var(--color-neutral-800))]" data-id="element-233">
                {problem.text}
              </p>
            </div>)}
        </div>

        <div className="animate-bounce mt-6 sm:mt-16" data-id="element-234">
          <ChevronDownIcon className="w-10 h-10 sm:w-12 sm:h-12 mx-auto text-[rgb(var(--color-primary))]" data-id="element-235" />
        </div>
      </div>
    </section>;
}